import React from 'react'
import { T } from '@transifex/react'

import { pathJoin } from 'src/reducers/routing/utils'

import { createDetailRoutesMap } from './detailed-view'

export const createContactRoutesMap = (prefix: string) => ({
  create: pathJoin(prefix)('create').chainWithTitle({
    title: <T _str="Create Contact" />,
    breadCrumbTitle: <T _str="Create Contact" />,
  }),
  '/:id': (id: string) =>
    pathJoin(prefix)('id')(id).chainMapAuto(createDetailRoutesMap, {
      title: <T _str="Contact Details" />,
      breadCrumbTitle: <T _str="Contact Details" />,
    }),
})
